import { QUOTE_PRODUCT_ID } from '@vertex-protocol/contracts';
import { EQUITY_TOKEN_ICONS } from './equityTokenIcons';
import { MarketCategory, PerpProductMetadata } from './types';

/**
 * Auto-generates PerpProductMetadata for TradFi perp markets (equities, ETFs,
 * commodities, forex) using the EQUITY_TOKEN_ICONS registry.
 *
 * Market name format: `${symbol}-PERP` (e.g. "AAPL-PERP", "EURUSD-PERP").
 * This matches the Nado API symbol format and produces clean URL parameters.
 *
 * @param symbol - Uppercase ticker symbol (must be a key in EQUITY_TOKEN_ICONS)
 * @param additionalCategories - Extra MarketCategory values beyond 'perp'
 *   e.g. ['equities'] for stocks/ETFs, ['commodity'] for XAG/WTI, ['forex'] for FX pairs
 */
export function createEquityPerpMetadata(
  symbol: string,
  additionalCategories: MarketCategory[] = [],
): PerpProductMetadata {
  const icon = EQUITY_TOKEN_ICONS[symbol];
  if (!icon) {
    throw new Error(
      `createEquityPerpMetadata: no icon registered for symbol "${symbol}". Add it to EQUITY_TOKEN_ICONS first.`,
    );
  }
  return {
    symbol,
    icon,
    marketName: `${symbol}-PERP`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['perp', ...additionalCategories]),
  };
}
